/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Legal_JoinerInputs */

const en_login_page_legal_joiner = /** @type {(inputs: Login_Page_Legal_JoinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and`)
};

const de_login_page_legal_joiner = /** @type {(inputs: Login_Page_Legal_JoinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`und`)
};

const pt_br2_login_page_legal_joiner = /** @type {(inputs: Login_Page_Legal_JoinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e a`)
};

const tr_login_page_legal_joiner = /** @type {(inputs: Login_Page_Legal_JoinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ve`)
};

const zh_cn2_login_page_legal_joiner = /** @type {(inputs: Login_Page_Legal_JoinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`和`)
};

const zh_hk2_login_page_legal_joiner = /** @type {(inputs: Login_Page_Legal_JoinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`和`)
};

const ko_kr2_login_page_legal_joiner = /** @type {(inputs: Login_Page_Legal_JoinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`및`)
};

const ru_ru2_login_page_legal_joiner = /** @type {(inputs: Login_Page_Legal_JoinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`и`)
};

const es_419_login_page_legal_joiner = /** @type {(inputs: Login_Page_Legal_JoinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`y`)
};

/**
* | output |
* | --- |
* | "and" |
*
* @param {Login_Page_Legal_JoinerInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_legal_joiner = /** @type {((inputs?: Login_Page_Legal_JoinerInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Legal_JoinerInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_legal_joiner(inputs)
	if (locale === "de") return de_login_page_legal_joiner(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_legal_joiner(inputs)
	if (locale === "tr") return tr_login_page_legal_joiner(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_legal_joiner(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_legal_joiner(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_legal_joiner(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_legal_joiner(inputs)
	return es_419_login_page_legal_joiner(inputs)
});